import React, { Component, createRef } from 'react';
import './AlertManager.css';

class AlertManager extends Component {
  timer = null;
  prevMessageRef = createRef();

  state = {
    visible: false,
    // currentMessage: `Bet Accepted !! your bet amount is ${1000}`,
    currentMessage: ``,
  };

  componentDidMount() {
    this.prevMessageRef.current = null;
    this.showAlertIfNeeded(this.props.message);
  }

  componentDidUpdate(prevProps) {
    // We won't use this anymore per your request
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  showAlertIfNeeded = (message) => {
    const { duration = 2000 } = this.props;
    if (!message) return;

    if (message !== this.prevMessageRef.current) {
      // New message, show alert
      clearTimeout(this.timer);
      this.setState({ visible: true, currentMessage: message });

      this.timer = setTimeout(() => {
        this.setState({ visible: false, currentMessage: '' });
      }, duration);

      this.prevMessageRef.current = message;
    } else {
      // Same message repeated — reset alert to show again
      clearTimeout(this.timer);
      this.setState({ visible: false }, () => {
        this.setState({ visible: true, currentMessage: message });

        this.timer = setTimeout(() => {
          this.setState({ visible: false, currentMessage: '' });
        }, duration);
      });
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    // We cannot call setState here or refs, so this hook won't help us trigger alerts directly.
    return null;
  }

  render() {
    const { visible, currentMessage } = this.state;
    const { duration = 3000 ,isPotrait} = this.props;

    if (!visible) return null;

    return (
      <div className="fd maincontain">
        <div className={`alert-message show ${isPotrait?'col-12':'col-6'}`}>
          {currentMessage}
          <div
            className="alert-spinner"
            style={{ animationDuration: `${duration}ms` }}
          />
        </div>
      </div>
    );
  }
}

export default AlertManager;
